var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    fill: "#fdcd41",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.58 75.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.59,33.16L82.03,0h-42.24C25.84,0,13.79,9.77,10.91,23.42L0,75.1h18.04l29.99-35.25-11.3-25.11h10.46l7.39,18.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.17,0l-33.95,39.86,10.88,24.41h-10.39l-6.97-17.72-23.58,28.55h44.06c13.71,0,25.54-9.6,28.37-23.01L111.58,0h-19.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLogo);
export default __webpack_public_path__ + "static/media/mob-logo.dad129905e5fea85b2039d8521d01b39.svg";
export { ForwardRef as ReactComponent };